import { createAsyncThunk } from '@reduxjs/toolkit';

import { deleteScene } from '../../../services/scene';
import type { Scene } from '../../../types/scene';
import { isPerspectiveSharingAvailable } from '../../connections/connectionsDuck';
import { getPerspective } from '../../perspectives/perspectives.selector';
import { isSharedStorageAvailable, sharedStorageApi } from '../../shared-storage/shared-storage.api';
import type { RootState } from '../../types';
import { NAME } from './const';

type DeleteScenePayload = {
  sceneId: Scene['id'];
};

export const deleteSceneThunk = createAsyncThunk<Scene['id'], DeleteScenePayload, { state: RootState }>(
  `${NAME}/deleteSceneThunk`,
  async ({ sceneId }, { dispatch, getState }) => {
    const state = getState();
    const perspective = getPerspective(state);
    const isPluginPresent = isPerspectiveSharingAvailable(state);

    if (!perspective) {
      throw Error('Perspective not found');
    }

    if (isPluginPresent) {
      await deleteScene(perspective.id, sceneId);
    } else if (isSharedStorageAvailable()) {
      const { id } = await dispatch(sharedStorageApi.endpoints.deleteScene.initiate(sceneId)).unwrap();

      if (typeof id !== 'string') {
        throw Error('Could not delete the scene from shared storage.');
      }
    }

    return sceneId;
  },
);
